<div class="editable-select-container" (mouseenter)="toggleEditButton(true)" (mouseleave)="toggleEditButton(false)">
    <div class="editable-select-wrapper">
        <div class="editable-select">
            <!-- Display Mode -->
            @if(!isEditMode()){
                <span class="display-mode" [class]="displayValue?'cursor-pointer':'cursor-default'" [style.min-height.px]="minHeight()" (click)="onDisplayValueClicked()">
                    {{ displayValue || '&nbsp;' }}
                </span>
            }
            <!-- Edit Mode - Autocomplete -->
            @else{
                @if(autocomplete()){
                    <div class="autocomplete-container">
                        <input
                            #inputElement
                            type="text"
                            [(ngModel)]="searchText"
                            [ngModelOptions]="{ standalone: true }"
                            (input)="onSearchInput($event)"
                            (blur)="onBlur()"
                            (focus)="onFocus()"
                            (keydown)="onKeyDown($event)"
                            [disabled]="disabled"
                            [placeholder]="placeholder()"
                            class="edit-mode autocomplete-input"
                            autocomplete="off"
                        />
                        @if(showDropdown){
                            @if(filteredOptions.length > 0){
                                <div class="autocomplete-dropdown">
                                    @for(option of filteredOptions; track $index; let i = $index){
                                        <div class="option" [class.highlighted]="i === highlightedIndex" [class.selected]="isSelected(option)" (mousedown)="selectOption(option)" (mouseenter)="highlightedIndex = i">
                                            @if(displayPath()){ {{option[displayPath()!]}} }
                                            @else { {{option}} }
                                        </div>
                                    }
                                </div>
                            }
                            @else{
                                <div class="autocomplete-dropdown no-results">
                                    No matches found
                                </div>
                            }
                        }
                    </div>
                }
                @else{
                    <!-- Edit Mode - Custom Select -->
                    <div class="select-trigger" [class.open]="showSelectDropdown" (click)="toggleSelectDropdown()">
                        <span class="select-display" [class.placeholder]="!displayValue" [class.disabled]="disabled">{{ displayValue || placeholder() || '&nbsp;' }}</span>
                        @if(!disabled){<span class="select-arrow"></span>}
                    </div>
                    @if(showSelectDropdown){
                        <div class="autocomplete-dropdown select-dropdown">
                            @if(placeholder()){
                                <div class="option" [class.selected]="!value" (mousedown)="onSelectChange(null)">
                                    <span class="placeholder-option">{{ placeholder() }}</span>
                                </div>
                            }
                            @for(option of options(); track $index; let i = $index){
                                <div class="option"
                                    [class.highlighted]="i === highlightedIndex"
                                    [class.selected]="isSelected(option)"
                                    (mousedown)="selectCustomOption(option)"
                                    (mouseenter)="selectHighlightedIndex = i">
                                    @if(displayPath()){ {{option[displayPath()!]}} }
                                    @else { {{option}} }
                                </div>
                            }
                        </div>
                    }
                }
            }
        </div>
    </div>
 
    <!-- Edit Button -->
    @if(allowIndividualEditMode() && !isEditMode() && showEditButton){
        <button
            type="button"
            class="edit-button"
            (click)="enterEditMode()"
            title="Edit">
            ✎
        </button>
    }
</div>